import React from "react";
import {Redirect, Route, Switch} from "react-router-dom";
import {ErrorPage1} from "./ErrorPage1";

export default function ErrorsPage() {
    return (
        <Switch>
            <Redirect from="/error" exact={true} to="/error/not_found"/>
            <Route path="/error/not_found" component={ErrorPage1}/>

            {
                /* 404 NOT Found */
                <Redirect to="/error/not_found"/>
            }
        </Switch>
    );
}
